import { render, staticRenderFns } from "./snippet.vue?vue&type=template&id=260e53fc&"
import script from "./snippet.vue?vue&type=script&lang=js&"
export * from "./snippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports